import { Box, Card, CardContent, Grid, Typography, Accordion, AccordionDetails, AccordionSummary, DialogTitle } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../../context/UserContext";
import StrategiesListEdit from './Strategies_List_Edit';
import { Container, Stack } from '@mui/system';
import { BASE_URL } from "../../baseUrl"

const MyStrategiesPage = () => {
  const [login, setLogin] = React.useContext(UserContext);
  const navigate = useNavigate();
  const [Commitments, setCommitments] = useState([]);
  const [expanded, setExpanded] = useState('panel1');

  useEffect(() => {
    window.scrollTo(0, 0);
    getProfile();
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const getProfile = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + login.token,
      },
    };
    const response = await fetch(BASE_URL + "/api/strategy/list", requestOptions);
    if (!response.ok) {
      console.error("Failed to fetch strategies");
      // Handle error
    } else {
      const data = await response.json();
      setCommitments(data);
    }
  };

  const onSubmitReloadAll = (trigger) => {
    if (trigger) {
      getProfile();
    }
  };

  return (
    <Box sx={{ flexGrow: 1, py: 8 }}>
      <Container maxWidth="lg">
      <Stack spacing={10}>
      <div>
      <Grid  container spacing={5} direction="column" alignItems="center">
      <Grid item xs={12} md={6} lg={8} sx={{}}>
      

          <Grid container direction="column" spacing={2}>
          <DialogTitle color="white">
            Reporting Progress & Creating New Strategies <br></br>
            <Typography color="gray">Items listed below are editable. These are Strategies you own or have been granted access to edit</Typography>
            <Typography color="gray">You can create new strategies in this section</Typography>
          </DialogTitle>
          </Grid>
                   

      <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
        <Grid container spacing={5} direction="column" alignItems="center">
          <Grid xs={11} md={9} lg={9}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                sx={{ backgroundColor: '#444', opacity: '99%' }}
              >
                <Typography sx={{ width: '33%', flexShrink: 0, color: 'white' }} >
                  MY STRATEGIES
                </Typography>
                <Typography sx={{ color: 'lightgray' }}>
                  Editable strategies (you own and/or have control)
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#444', opacity: '97%' }}>
                <Grid container spacing={2}>
                  {Commitments.Private && Commitments.Private.length > 0 ? (
                    Commitments.Private.map((group, index) => (
                      <Grid item xs={12} key={index}>
                        <StrategiesListEdit
                          title={`Group ${index + 1} - ${group.Name}`}
                          list={group.strategy_list}
                          id_client={group.ID_Client}
                          onSubmitReloadAll={onSubmitReloadAll}
                        />
                      </Grid>
                    ))
                  ) : (
                    <Typography color='whitesmoke' sx={{ padding: '2rem' }} >YOU ARE NOT LOGGED IN! After loggin in, make sure to become a Signatory thru your Profile Manager page, so you can add ACTIONS & STRATEGIES to your account! </Typography>
                  )}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Box>
      </Grid>
      </Grid>
      </div>
      </Stack>
      </Container>
    </Box>
  );
}

export default MyStrategiesPage;
